import { render, staticRenderFns } from "./ManifestacaoFormLayout.vue?vue&type=template&id=1a561aed&scoped=true&"
import script from "./ManifestacaoFormLayout.vue?vue&type=script&lang=js&"
export * from "./ManifestacaoFormLayout.vue?vue&type=script&lang=js&"
import style0 from "@/styles/manifestacao.scss?vue&type=style&index=0&id=1a561aed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a561aed",
  null
  
)

export default component.exports